import React from "react";



const Angular = () => {
return(
    
<>

<section class="about1" id="">

<div class="max-width" >
{/* <!-- <h2 class="title">About me</h2> --> */}
<div class="about-content">

<div class=" right">
<div class="text">Angular</div>
<h3>Hire the best Angular Developers in Mumbai<br/>
<span>ShellCode Solutions, the best Angular developer in Mumbai, offers its top-notch development services to make your life hassle-free and increase your brand’s productivity.<br/>
Custom Hiring Models<br/>
On-Time delivery<br/>
Dexterous development methodology<br/>
Source Code Authorization<br/>
</span>
</h3>
</div>
<div class=" left">
<img src="assets/images/1.png" alt="1"/>
</div>
</div>

</div>
</section>
<div className="extra">
    <h3>Angular Development Services we provide:<br/>
    <span>
    Custom Angular Development: Our team of Angular Developers provides solutions tailor-made for your specific requirements to improve performance.<br/>
Ajax development: Our developers are proficient in technologies like CSS, XML request (XHR), JavaScript and XHTML.<br/>
Web and API services integration: Integration of APIs into various software applications has been made easy by our skilled Angular developers at ShellCode Solutions.<br/>
Angular Maintenance and Support: Testing, maintenance, and support as and when you need it! What could be better than this?<br/>
UI/UX Development: Aesthetically pleasing and responsive UI/UX are just a step away!<br/>
Angular Consulting: We provide Angular consulting and build applications that increase the productivity and efficiency of your brand.
    </span></h3>
    
    <h3>Why hire ShellCode Solutions, the best Angular developers in Mumbai?<br/>
    <span>
    Why come to us? How are we different in what we offer? Here’s the answer to these questions.<br/>
Proficient team: We have a team of highly skilled professionals who deliver Angular solutions for your every need.<br/>
Profound Technical Knowledge: We do not boast! But we are simply the best!<br/>
Stay updated: We keep you in the loop and follow a highly transparent process for your peace of mind.<br/>
Agile process: We conduct continuous testing before deployment and deliver the product efficiently.<br/>
Accessible team: We are available and accessible whenever you need us.<br/>
Economical costs: We offer cost-efficient Angular solutions to keep your budgetary concerns away.
    <br/></span>
    </h3>

    <h3>Technologies and Tools We use<br/>
    <span>We utilize our inventory of tools and top-notch technology to come up with optimal and efficient Angular solutions.<br/>
    </span>
    </h3>
    <h3>Customizable packages for your requirements<br/>
    <span>We provide multiple engagement models for you to choose from so that you get the service you deserve!<br/>
    </span>
    </h3>
    <h3>Customizable packages for your requirements<br/>
    <span>We provide you with a plethora of options to choose from when it comes to business models, as we realize that no two projects are the same. Get a tailor-made custom package specifically designed for you.<br/>
    </span>
    </h3>

   
</div>
    </>
)
}

export default Angular;
